<template>
  <div class="voice-room-chat">
    <!-- Messages Container -->
    <div
      ref="messagesContainer"
      class="messages-container"
    >
      <div
        v-for="(message, index) in messages"
        :key="index"
        class="message-item"
        :class="{ 'gift-message': message.type === 'gift' }"
      >
        <!-- Hediye satışı kaldırıldı — hediye mesajı gösterilmiyor -->
        <template v-if="false && message.type === 'gift'">
          <div class="gift-message-content">
            <b-avatar
              :src="message.sender && message.sender.avatar"
              size="24px"
              class="mr-2"
            />
            <span class="gift-sender mr-1">
              {{ message.sender.name }}
            </span>
            <img
              :src="message.gift.image"
              :alt="message.gift.name"
              class="gift-icon"
            />
          </div>
        </template>

        <!-- Regular Message -->
        <template v-else>
          <div class="message-sender-info d-flex align-items-center">
            <b-avatar
              :src="message.sender && message.sender.avatar"
              size="24px"
              class="mr-2"
            />
            <span class="sender-name">
              {{ message.sender ? message.sender.name : this.$t('Unknown') }}
            </span>
          </div>
          <div class="message-content ml-4">
            {{ message.content }}
          </div>
        </template>
      </div>
    </div>

<!-- Hediye satışı kaldırıldı — hızlı hediye barı devre dışı
    <QuickGiftBar
      v-if="availableGifts && !isHost"
      :gifts="availableGifts"
      class="mb-1"
      @send-gift="handleQuickGiftSelected"
    />
    -->

    <!-- Input Area -->
    <div class="chat-input-area">
      <div class="input-wrapper">
        <input
          v-model="messageText"
          type="text"
          placeholder="Type a message..."
          @keyup.enter="sendMessage"
        />
        <button
          v-if="false"
          class="gift-button"
          @click="$emit('open-gift-panel')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M20 12v10H4V12M22 7H2v5h20V7zM12 22V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
          </svg>
        </button>
        <button
          class="send-button"
          :disabled="!messageText.trim()"
          @click="sendMessage"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M22 2L11 13M22 2L15 22 11 13 2 9 22 2z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'
import QuickGiftBar from './QuickGiftBar.vue'

export default {
  name: 'VoiceRoomChat',
  components: {
    BAvatar,
    QuickGiftBar,
  },

  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    isHost: {
      type: Boolean,
      default: false,
    },
    availableGifts: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      messageText: '',
    }
  },

  computed: {
    // reversedMessages computed property removed
  },

  watch: {
    messages: {
      handler() {
        // Scroll to bottom when messages change
        this.$nextTick(() => {
          this.scrollToBottom() // Call scrollToBottom
        })
      },
      deep: true,
    },
  },

  mounted() {
    this.$nextTick(() => {
      // Set initial scroll to the bottom
      this.scrollToBottom() // Call scrollToBottom
    })
  },

  methods: {
    sendMessage() {
      const text = this.messageText.trim()
      if (text) {
        this.$emit('send-message', text)
        this.messageText = ''
      }
    },

    scrollToBottom() { // Renamed method
      const container = this.$refs.messagesContainer
      if (container) {
        // Scroll to the bottom
        container.scrollTop = container.scrollHeight
      }
    },

    handleQuickGiftSelected(gift) {
      // Emit another event upwards to Index.vue
      this.$emit('send-quick-gift', gift)
    },
  },
}
</script>

<style lang="scss" scoped>
.voice-room-chat {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  margin: 16px;
  margin-top: auto;
  height: 280px;

  .messages-container {
    flex: 1;
    overflow-y: auto;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .message-item {
      .message-sender-info {
        .sender-name {
        font-size: 14px;
        font-weight: 600;
        color: #A644FB;
        }
      }

      .message-content {
        color: white;
        font-size: 14px;
        line-height: 1.4;
      }

      &.gift-message {
        padding: 12px 0;
        border-radius: 8px;

        .gift-message-content {
          display: flex;
          align-items: center;
          color: white;
          font-size: 14px;

          .gift-icon {
            width: 24px;
            height: 24px;
          }

          .gift-sender {
            color: #A644FB;
            font-weight: 600;
          }

          .gift-name {
            color: #FF9500;
            font-weight: 600;
          }
        }
      }
    }
  }

  .chat-input-area {
    flex-shrink: 0;
    padding: 10px 15px;
    background: rgba(0, 0, 0, 0.3);

    .input-wrapper {
      display: flex;
      gap: 12px;
      align-items: center;

      input {
        flex: 1;
        background: rgba(255, 255, 255, 0.1);
        border: none;
        border-radius: 25px;
        padding: 12px 20px;
        color: white;
        font-size: 14px;

        &::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }

        &:focus {
          outline: none;
          background: rgba(255, 255, 255, 0.15);
        }
      }

      button {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        cursor: pointer;
        transition: all 0.2s;

        &:hover:not(:disabled) {
          transform: scale(1.05);
        }

        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        svg {
          width: 20px;
          height: 20px;
          stroke: currentColor;
        }
      }

      .gift-button {
        background: #FF9500;
      }

      .send-button {
        background: #A644FB;
      }
    }
  }

  .quick-gift-bar {
    padding: 8px 15px;
    margin-bottom: 0;
    flex-shrink: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    max-height: 70px;

    display: flex;
    overflow-x: auto;
    // Hide scrollbar visually but keep functionality
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }

  @media (min-width: 992px) {
    height: 360px;
  }
}
</style>
